module.exports = __webpack_public_path__ + "img/plat_4876.fb949a96.jpg";